<template>
    <v-autocomplete
            v-bind="$attrs"
            v-model="computedSelectedItens"
            :items="items"
            :label="label"
            :disabled="disabled"
            :loading="loading"
            :menu-props="{ maxHeight: 400, allowOverflow: true }"
            :readonly="readonly"
            :filled="filled"
            :search-input.sync="searchText"
            :item-text="itemText"
            :item-value="itemValue"
            :chips="multiple"
            class="select_delete_to_left"
            hide-selected
            :return-object="returnObject"
            autocomplete="off"
            :no-data-text="!searchText ? 'Escreva para buscar' : mensagem_no_data"
            deletable-chips
            outlined
            :cache-items="cacheItems"
            :multiple="multiple"
            :append-icon="clearIcon"
            @click:append="handleClearSelection"
    >
    </v-autocomplete>
</template>

  <script>
  import { asyncConfirmationDialog } from '@/plugins/helpers'

  const TEMPO_ESPERA_PARA_PESQUISAR_A_API = 425
  export default {
    name: 'DynamicSelect',
    props: {
      value: [Array, String, Number, Object],
      label: String,
      endpoint: String,
      itemText: { type: [String, Array, Function], default: 'label' },
      itemValue: { type: [String, Array, Function], default: 'id' },
      disabled: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      filled: { type: Boolean, default: false },
      multiple: { type: Boolean, default: true },
      returnObject: { type: Boolean, default: false },
      params: { type: Object, default: () => ({}) },
      cacheItems: { type: Boolean, default: true },
      options: { type: Object, default: () => ({}) },
      filterFunction: { type: Function, default: null },
      confirmOnClear: { type: Boolean, default: false }
    },
    data () {
      return {
        searchText: '',
        items: [],
        timeout: null,
        loading: false,
        mensagem_no_data: '',
        ultimosItensEnviados: null
      }
    },
    computed: {
      computedSelectedItens: {
        get () {
          return this.value
        },
        set (itensSelecionados) {
          this.ultimosItensEnviados = itensSelecionados
          this.$emit('input', itensSelecionados)
          this.clearSearchText()
        }
      },
      clearIcon () {
        if (this.multiple) {
          return this.computedSelectedItens.length ? 'mdi-close' : 'mdi-menu-down'
        } else {
          return this.computedSelectedItens ? 'mdi-close' : 'mdi-menu-down'
        }
      }
    },
    watch: {
      searchText () {
        this.searchItems()
      },
      value (newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.ultimosItensEnviados) && newValue && newValue.length > 0) {
          this.searchItems(true)
        }
      }
    },
    mounted () {
      this.buscarNaApi(true)
    },
    methods: {
      async searchItems (forcarBusca = false) {
        clearTimeout(this.timeout)
        this.error = false
        this.loading = false
        if (!this.searchText && !forcarBusca) {
          return
        }
        this.mensagem_no_data = 'Buscando...'
        this.timeout = setTimeout(async () => this.buscarNaApi(forcarBusca), TEMPO_ESPERA_PARA_PESQUISAR_A_API)
      },
      async buscarNaApi (forcarBusca) {
        this.loading = true
        let ids = this.multiple ? this.computedSelectedItens.join(',') : this.computedSelectedItens
        if (ids === null || ids === 'null') {
          ids = ''
        }
        const apiUrl = `${this.endpoint}?ids=${ids}&searchText=${this.searchText}`
        const params = this.params || {}
        const options = { silent: !forcarBusca, ...this.options }
        await this.$http.get(apiUrl, { params, options })
          .then(response => {
            let items = response.data.items
            if (this.filterFunction) {
              items = this.filterFunction(items)
            }
            this.items = items
          }).catch(() => {
            this.error = true
          }).finally(() => {
            this.loading = false
            this.mensagem_no_data = 'Nenhum registro encontrado'
          })
      },
      clearSearchText () {
        this.searchText = ''
      },
      async handleClearSelection (event) {
        event.stopPropagation()
        if (!this.computedSelectedItens.length && this.multiple) return
        if (!this.computedSelectedItens && !this.multiple) return

        if (this.confirmOnClear) {
          const confirmed = await asyncConfirmationDialog('Tem certeza de que deseja remover todos os itens selecionados?')
          if (confirmed) {
            this.$emit('input', this.multiple ? [] : null)
          }
        } else {
          this.$emit('input', this.multiple ? [] : null)
        }
      }
    }
  }
  </script>

  <style scoped>
  .closeButtonOnLeft {
    order: 2;
    margin-left: 1rem;
  }
  </style>
